const formatNumber = (num: number) => {
  if (num >= 1_000_000_000) return (num / 1_000_000_000).toFixed(1) + "B";
  if (num >= 1_000_000) return (num / 1_000_000).toFixed(1) + "M";
  if (num >= 1_000) return (num / 1_000).toFixed(1) + "K";
  return num;
};
interface Props {
  value: number;
}
export function ShortNumber({
  value
}: Props) {
  return <span data-sentry-component="ShortNumber" data-sentry-source-file="ShortNumber.tsx">{formatNumber(value)}</span>;
}